module.exports = __webpack_public_path__ + "img/glory-days.9fe4e71f.jpg";